/* eslint-disable import/no-cycle */
import Vue from 'vue';

const MODULE_ROUTE = 'subscription-codes';

export default {
  query(params) {
    return Vue.axios.get(MODULE_ROUTE, { params }).catch((error) => {
      throw new Error(`${error}`);
    });
  },
  create(data) {
    return Vue.axios.post(MODULE_ROUTE, data).catch((error) => {
      throw new Error(`${error}`);
    });
  },
  delete(id) {
    return Vue.axios.delete(`${MODULE_ROUTE}/${id}`).catch((error) => {
      throw new Error(`${error}`);
    });
  },
  checkCode(data) {
    return Vue.axios.post(`${MODULE_ROUTE}/check-code`, data).catch((error) => {
      throw new Error(`${error}`);
    });
  },
};
